var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 51,
    rx: 4,
    fill: "#3D3E4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5774 23.7145C20.0352 23.7145 17.8597 23.435 16.0509 22.876C14.242 22.3169 13.3361 21.6441 13.333 20.8574V15.8574C13.333 15.0717 14.239 14.3993 16.0509 13.8402C17.8628 13.2812 20.0383 13.0012 22.5774 13.0002H38.7552C41.2974 13.0002 43.4745 13.2802 45.2864 13.8402C47.0983 14.4002 48.0027 15.0726 47.9997 15.8574V20.8574C47.9997 21.6431 47.0953 22.316 45.2864 22.876C43.4776 23.436 41.3005 23.7155 38.7552 23.7145H22.5774ZM22.5774 38.7145C20.0352 38.7145 17.8597 38.435 16.0509 37.876C14.242 37.3169 13.3361 36.6441 13.333 35.8574V30.8574C13.333 30.0717 14.239 29.3993 16.0509 28.8402C17.8628 28.2812 20.0383 28.0012 22.5774 28.0002H38.7552C41.2974 28.0002 43.4745 28.2802 45.2864 28.8402C47.0983 29.4002 48.0027 30.0726 47.9997 30.8574V35.8574C47.9997 36.6431 47.0953 37.316 45.2864 37.876C43.4776 38.436 41.3005 38.7155 38.7552 38.7145H22.5774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewButton);
export default __webpack_public_path__ + "static/media/view_button.73c045b7a4838bd731fce98f81aa3e0a.svg";
export { ForwardRef as ReactComponent };